export const withoutUndefinedValues = <T>(obj: T): T => {
    const acc: Partial<T> = {};
    for (const key in obj) {
        if (obj[key] !== undefined) {
            acc[key] = obj[key];
        }
    }
    return acc as T;
};
